import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import UtcOffsetFieldEditComponent from'../tsx/UtcOffsetField';
//import validators = require('./validators');

export default class UtcOffsetField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];
    public static EditComponent = UtcOffsetFieldEditComponent;
    public static getDefaultValue() {
        return {};
    }

    constructor(glob: IGlob, title: string, validators?: any[], defaultVal?: any, options?: IParameterFieldBaseOptions) {
        if (defaultVal == null) {
            defaultVal = UtcOffsetField.getDefaultValue();
        }

        super(glob, title, UtcOffsetField.defaultValidators, validators, defaultVal, options);
    }
}